module.exports = __webpack_public_path__ + "img/yadda.5f94b7eb.svg";